import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'
import { SamAlertModal } from './SamAlertModal.component'

const withUnmountHoc = withUnmountTransition(SamAlertModal)
export { withUnmountHoc as SamAlertModal }
